import React from 'react';
import { IAuditoriaRotatividadeProvisoesResultado } from '../interfaces/IAuditoriaRotatividadeProvisoes';
import { TributoAuditoria } from '../interfaces/IAuditoria';
import { formatCurrency } from '../utils/formatters';

interface Props {
  resultado?: IAuditoriaRotatividadeProvisoesResultado;
  onSelecionar: (tributo: TributoAuditoria) => void;
}


// Governança e Rotatividade de Provisões — Controle de Estagnação. Provisões e obrigações
// operacionais (trabalhistas, fiscais, cíveis ou de contingência) sem rotatividade (estorno ou
// novo lançamento). Fundamentação: CPC 25 (IAS 37) / Instrução Normativa RFB sobre ECD.
const AuditoriaResumoRotatividadeProvisoes: React.FC<Props> = ({ resultado, onSelecionar }) => {
  if (!resultado) {
    return null;
  }

  const totalOcorrencias = (resultado.provisoesPendentes || []).length;

  return (
    <div className='auditoria-card mt-5'>
      <h3>Resumo de Rotatividade de Provisões (Controle de Estagnação)</h3>
      <p className='text-muted'>
        Provisões para Contingência (Trabalhista/Fiscal/Cível/Outras) sem rotatividade (estorno ou novo
        lançamento) configuram erro de competência (CPC 25 / IAS 37). Clique para ver a análise detalhada.
      </p>

      <div className='table-responsive mt-4'>
        <table className='auditoria-table auditoria-table-tributos'>
          <thead>
            <tr>
              <th>Auditoria</th>
              <th className='text-end'>Multa ECD / Saldo Estagnado</th>
              <th className='text-center'>Erros</th>
              <th className='text-center'>Avisos</th>
              <th className='text-center'>Alertas</th>
            </tr>
          </thead>

          <tbody>
            <tr className='auditoria-row-tributo' onClick={() => onSelecionar('AUDITORIA_ROTATIVIDADE_PROVISOES')}>
              <td className='auditoria-col-tributo'>
                <div className='d-flex align-items-center gap-2'>
                  <strong>Governança e Rotatividade de Provisões</strong>
                  <span className={`auditoria-status status-${resultado.status}`}>
                    {resultado.status}
                  </span>
                </div>
                <div className='auditoria-legislacao-inline'>
                  <div>{totalOcorrencias} provisão{totalOcorrencias === 1 ? '' : 'ões'} sem rotatividade identificada{totalOcorrencias === 1 ? '' : 's'} no período</div>
                  <div className='text-muted'>{resultado.mensagemDirecionamento}</div>
                </div>
              </td>
              <td className='text-end auditoria-col-highlight'>
                {formatCurrency(resultado.impactoFiscalTotal)}
                <div className='auditoria-kpi-help'>Saldo estagnado total: {formatCurrency(resultado.impactoFinanceiroTotal)}</div>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-erro'>{resultado.totalErros}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-aviso'>{resultado.totalAvisos}</span>
              </td>
              <td className='text-center'>
                <span className='auditoria-contador auditoria-contador-alerta'>{resultado.totalAlertas}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AuditoriaResumoRotatividadeProvisoes;
